<script>
export let question;


import { slide } from 'svelte/transition';


let open = false;

function changeOpen() {
	open = !open;
}

function closeOpen() {
	open = false;
}


</script>



<style>

.question {
	margin-bottom: 2rem;
	height: unset !important;
	transition: all ease 0.15s;
}

.question:hover {
	cursor: pointer;
}

.question.open {
	
}

.card-content {
	padding: 1rem 1rem !important;
}

.question-title {
	font-size: 1.125rem;
	color: var(--text-dark);
}

.question-body {
	margin-top: 0.875rem;
}

.question-body p {
	color: var(--text-grey);
}

</style>



<div class="question card hoverable" class:open={open} on:click={changeOpen}>

	<div class="card-content">

		<div class="columns is-variable is-3 is-mobile question-top" style="margin-bottom: 0;">

			<div class="column" style="padding-bottom: 0;">
				<p class="question-title">{question.title}</p>
			</div>

			<div class="column is-narrow" style="padding-bottom: 0;">
				<i class="fal fa-plus" class:is-hidden="{open}"></i>
				<i class="fal fa-minus" class:is-hidden="{!open}"></i>
			</div>

		</div>

		<div class="question-body" class:is-hidden={!open}>
			<p>{question.text}</p>
		</div>

	</div>

</div>




